import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { safeLs } from 'utils/localStorage';

import commonBN from './bn/common.json';
import paymentsBN from './bn/payments.json';
import accountEN from './en/account.json';
import authEN from './en/auth.json';
import commonEN from './en/common.json';
import customersEN from './en/customers.json';
import menuEN from './en/menu.json';
import paymentsEN from './en/payments.json';
import topUpsEN from './en/top_ups.json';
import traderAccountEN from './en/trader_account.json';
import traderDepositsEN from './en/trader_deposits.json';
import traderPayoutsEN from './en/trader_payouts.json';
import traderStatisticsEN from './en/trader_statistics.json';
import withdrawalsEN from './en/withdrawals.json';
import commonHI from './hi/common.json';
import paymentsHI from './hi/payments.json';
import commonPT from './pt/common.json';
import paymentsPT from './pt/payments.json';
import accountRU from './ru/account.json';
import authRU from './ru/auth.json';
import commonRU from './ru/common.json';
import customersRU from './ru/customers.json';
import menuRU from './ru/menu.json';
import paymentsRU from './ru/payments.json';
import topUpsRU from './ru/top_ups.json';
import traderAccountRU from './ru/trader_account.json';
import traderDepositsRU from './ru/trader_deposits.json';
import traderPayoutsRU from './ru/trader_payouts.json';
import traderStatisticsRU from './ru/trader_statistics.json';
import withdrawalsRU from './ru/withdrawals.json';
import commonTA from './ta/common.json';
import paymentsTA from './ta/payments.json';

export const defaultNS = 'common';

export const resources = {
  en: {
    account: accountEN,
    auth: authEN,
    common: commonEN,
    customers: customersEN,
    menu: menuEN,
    payments: paymentsEN,
    ['top_ups']: topUpsEN,
    withdrawals: withdrawalsEN,
    ['trader_deposits']: traderDepositsEN,
    ['trader_payouts']: traderPayoutsEN,
    ['trader_account']: traderAccountEN,
    ['trader_statistics']: traderStatisticsEN,
  },
  ru: {
    account: accountRU,
    auth: authRU,
    common: commonRU,
    customers: customersRU,
    menu: menuRU,
    payments: paymentsRU,
    ['top_ups']: topUpsRU,
    withdrawals: withdrawalsRU,
    ['trader_deposits']: traderDepositsRU,
    ['trader_payouts']: traderPayoutsRU,
    ['trader_account']: traderAccountRU,
    ['trader_statistics']: traderStatisticsRU,
  },
  // Only the public payment pages and the crash screen are translated to Hindi, Bengali and Tamil (used for INR) and Portuguese (used for PIX)
  hi: {
    common: commonHI,
    payments: paymentsHI,
  },
  bn: {
    common: commonBN,
    payments: paymentsBN,
  },
  ta: {
    common: commonTA,
    payments: paymentsTA,
  },
  pt: {
    common: commonPT,
    payments: paymentsPT,
  },
} as const;

const lng = safeLs?.getItem?.('i18n') ?? 'ru';
export const supportedLanguages = Object.keys(resources);
// Languages offered in the language switcher (Indian languages are payment page only)
export const selectableLanguages = ['en', 'ru'];
// Languages offered on the INR payment page; the first one is the default
export const inrPaymentLanguages = ['hi', 'en', 'bn', 'ta'];
export const pixPaymentLanguages = ['pt', 'en'];

export const i18n = i18next.use(initReactI18next).init({
  resources,
  supportedLngs: supportedLanguages,
  lng,
  fallbackLng: {
    hi: ['en'],
    bn: ['en'],
    ta: ['en'],
    pt: ['en'],
    default: ['ru'],
  },
  ns: Object.keys(resources.en),
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});
